module.exports = __webpack_public_path__ + "img/1._Bergungsgruppe.7ad0d930.svg";